import React, { useEffect, useRef, useState } from 'react';

import './imageUpload.css';
import { Button } from '@mui/material';

const ImageUpload = props => {

    const [file, setFile] = useState();
    const [previewUrl, setPreviewUrl] = useState();
    const [isValid, setIsValid] = useState(false);

    const [selected, setSelected] = useState(false)

    const filePickerRef = useRef();

    const { onInput, id, image } = props;
    useEffect(() => {
        if(!file) {
            return;
        };
        const fileReader = new FileReader();
        fileReader.onload = () => {
            setPreviewUrl(fileReader.result);
        };

        fileReader.readAsDataURL(file);
    }, [file]);

    // User image 
    useEffect(() => {
        setFile(null);                         // Clears any previously selected file
        setPreviewUrl(image || null);          // Sets the preview to the new 'props.image' or null if no image is provided
        setIsValid(false);                     // Resets the 'isValid' state to 'false' (indicates no valid file is selected)
        onInput(id, null, false);              // Informs the parent component about the reset ( non file selected, and it's invalid)
    }, [image, onInput, id])                   // Runs every time 'props.image' changes
    


    const pickedHandler = (event) => {
        let pickedFile;
        let fileIsValid = isValid;
        if(event.target.files || event.target.files.length > 0) {
            pickedFile = event.target.files[0];
            setFile(pickedFile);
            setIsValid(true);
            setSelected(true)
            fileIsValid = true;
        } else {
            setIsValid(false);
            fileIsValid = false;
        }
        props.onInput(props.id, pickedFile, fileIsValid);
    }

    const pickImageHandler = () => {
        if (filePickerRef.current){
            filePickerRef.current.click();
        }
    }

  

    return (
        <main className='form-control'>
            <input 
                id={props.id} 
                style={{display: 'none'}} 
                type='file' 
                accept='image/*,video/*'
               
                onChange={pickedHandler}
                ref={filePickerRef}
            />
            <div className={`image-upload ${props.center & 'center'}`}>
                <div className='image-upload__preview'>
                    {previewUrl ? (
                        <img src={previewUrl} alt='Preview'/>
                    ) : (
                        <p>Please pick an image.</p>)
                    }
               
                {selected ? 
                    <Button id='but-ton' variant='contained' onClick={props.onClick}>change</Button> :
                    <Button id='but-ton' variant='contained' onClick={pickImageHandler}>Select Image</Button>
                    }
                </div>
                
                
            </div>
            {!isValid && <p>{props.errorText}</p>}
        </main>
    )
}
export default ImageUpload;